var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-card',{staticClass:"fit bg-white row items-center justify-center",attrs:{"id":"qy-cms-component-previewer"}},[_c(_vm.comName,{tag:"component",attrs:{"config":_vm.component.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }